import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

interface JobEvent {
  date: string;
  timeRange: string;
  worker: string;
  eventName: string;
  hours: number;
}

interface JobHoursGroup {
  jobCode: string;
  jobAddress: string;
  events: JobEvent[];
  totalHours: number;
}

interface JobHoursSectionProps {
  jobHours: JobHoursGroup[];
}

export function JobHoursSection({ jobHours }: JobHoursSectionProps) {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-xl font-bold mb-4">Job Hours</h2>
      {jobHours.length === 0 ? (
        <p className="text-gray-500">No events matched to jobs</p>
      ) : (
        <div className="space-y-6">
          {jobHours.map((job, idx) => (
            <div key={idx} className="border-t pt-4 first:border-t-0 first:pt-0">
              <h3 className="text-lg font-semibold mb-3 text-gray-900">
                <span className="text-blue-600 font-mono">[{job.jobCode}]</span> {job.jobAddress}
              </h3>
              <div className="overflow-x-auto">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Date</TableHead>
                      <TableHead>Time Range</TableHead>
                      <TableHead>Worker</TableHead>
                      <TableHead>Event Name</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {job.events.map((event, eventIdx) => (
                      <TableRow key={eventIdx}>
                        <TableCell>{event.date}</TableCell>
                        <TableCell>{event.timeRange}</TableCell>
                        <TableCell>{event.worker}</TableCell>
                        <TableCell>{event.eventName}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow className="bg-gray-50 font-bold">
                      <TableCell colSpan={4}>
                        Total Hours: {job.totalHours.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
